export default "__VITE_PUBLIC_ASSET__efac26e7__"